import { getTriangleBottomVertexes } from '../../../../../utilities/ShapeGenerators';
import getTopVertex from './topVertex';

const getPoints = shape => [
    getTopVertex(shape),
    ...getTriangleBottomVertexes(shape.get('width'), shape.get('height'))
];

export default getPoints;
